// Saves of one record, one after another: each starts when the one before it has returned, so it
// writes over the version that one saved — never over a version read before it landed, which the
// store refuses as "someone else changed it" (D160's versions). A quick Tab across a row's cells
// is two saves of one record. A failed save does not stop the next. No imports:
// `scripts/routing-checks.ts` checks it.

export type KeyedQueue = <T>(key: string, job: () => Promise<T>) => Promise<T>;

export function keyedQueue(): KeyedQueue {
  const tails = new Map<string, Promise<unknown>>();
  return (key, job) => {
    const next = (tails.get(key) ?? Promise.resolve()).catch(() => undefined).then(job);
    tails.set(key, next);
    // The last save of a key forgets it once done, so the map stays small.
    void next.finally(() => tails.get(key) === next && tails.delete(key)).catch(() => undefined);
    return next;
  };
}
